// extracted by mini-css-extract-plugin
module.exports = {"container":"PersonalLoanDetails_container__3fviY","upper":"PersonalLoanDetails_upper__3AgoT","list":"PersonalLoanDetails_list__1RW78"};